import { render, staticRenderFns } from "./ReceptionForm.vue?vue&type=template&id=57f1b7b4&"
import script from "./ReceptionForm.vue?vue&type=script&lang=js&"
export * from "./ReceptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports